import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { WordDataTypeEnum } from 'src/modules/shared/models/enums/word-data-type.enum';
import { IFileTable, IFileTableCell } from 'src/modules/shared/models/interfaces/files.interface';
import { IGroupTableConfigurationColumn } from 'src/modules/shared/models/interfaces/group-keys.interface';
import { IRobotWordTableColumn } from 'src/modules/shared/models/interfaces/robots.interface';

@Component({
  selector: 'hcr-robot-table-column-form',
  templateUrl: './robot-table-form.component.html',
  styleUrls: ['./robot-table-form.component.sass'],
})
export class RobotTableColumnFormComponent implements OnChanges {
  @Input() tableColumn: IRobotWordTableColumn;
  @Input() tableColumnConfiguration: IGroupTableConfigurationColumn;
  @Input() table: IFileTable;
  @Output() onCancel: EventEmitter<void> = new EventEmitter();
  @Output() onSave: EventEmitter<IRobotWordTableColumn> = new EventEmitter();
  @Output() onRemove: EventEmitter<IRobotWordTableColumn> = new EventEmitter();

  public tableColumnForm: FormGroup;

  constructor() {
    this.tableColumnForm = new FormGroup({
      columnIndex: new FormControl('', [Validators.required]),
      key: new FormControl('', [Validators.required]),
      type: new FormControl('', [Validators.required]),
    });
  }

  public cancel(): void {
    this.onCancel.emit();
  }

  public save(): void {
    this.onSave.emit({
      columnIndex: this.tableColumnForm.controls['columnIndex'].value,
      key: this.tableColumnForm.controls['key'].value,
      dataType: this.tableColumnForm.controls['type'].value,
    });
  }

  public getHeaderColumns(): IFileTableCell[] {
    return this.table.cells.filter((cell) => cell.isHeader);
  }

  public getTypes(): { key: number; value: string }[] {
    return Object.keys(WordDataTypeEnum)
      .filter((value) => isNaN(parseInt(value)))
      .map((value, key) => {
        return { key, value };
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.tableColumn?.currentValue) {
      this.tableColumnForm.controls['columnIndex'].setValue(this.tableColumn.columnIndex);
    }

    if (changes.tableColumnConfiguration?.currentValue) {
      this.tableColumnForm.controls['key'].setValue(this.tableColumnConfiguration.key);
      this.tableColumnForm.controls['type'].setValue(this.tableColumnConfiguration.type);
    }
  }
}
